// ./src/contexts/RemindersContext/RemindersContext.tsx
//
// Thin context wrapper around the useReminders hook. All derived data lives in the
// hook itself. See NotesContext for the pattern.

import React, { createContext, useContext } from "react";

import { useReminders, UseRemindersOptions, UseRemindersReturn } from "@/hooks/useReminders";

const RemindersContext = createContext<UseRemindersReturn | null>(null);

export interface RemindersProviderProps extends UseRemindersOptions {
  children: React.ReactNode;
}

export const RemindersProvider: React.FC<RemindersProviderProps> = ({ children, ...options }) => {
  const value = useReminders(options);

  return <RemindersContext.Provider value={value}>{children}</RemindersContext.Provider>;
};

export const useRemindersContext = (): UseRemindersReturn => {
  const context = useContext(RemindersContext);

  if (!context) {
    throw new Error(
      "useRemindersContext must be used within a <RemindersProvider>. " +
        "Wrap your component tree with <RemindersProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalRemindersContext = (): UseRemindersReturn | null => {
  return useContext(RemindersContext);
};
